export type OnlineStockData = {
  availabilityStatus: string;
  stockMessage: string;
};

export async function onlineStockFetcher(
  skuId: string,
  baseUrl: string,
  apiKey: string,
): Promise<OnlineStockData> {
  const url = `${baseUrl}?key=${apiKey}&skuIds=${skuId}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("Error calling Online Stock service");

  const data = await res.json();
  const { availabilityStatus, stockMessage } = data.stocks[0];
  return {
    availabilityStatus,
    stockMessage,
  };
}
